import action from 'utils/action';

export function advisoryStartTool() {
  return (dispatch) => {
    dispatch(action('ADVISORY_START_TOOL'));
  };
}

export function advisoryStoreCriteria(payload) {
  return (dispatch) => {
    dispatch(action('ADVISORY_STORE_CRITERIA', payload));
  };
}

export function advisoryRemoveCriteria(payload) {
  return (dispatch) => {
    dispatch(action('ADVISORY_REMOVE_CRITERIA', payload));
  };
}

export function advisoryResetCriteria() {
  return (dispatch) => {
    dispatch(action('ADVISORY_RESET_CRITERIA'));
  };
}



// WEBPACK FOOTER //
// ./js/actions/advisory.js